/*###########################################################################
// Header
//#########################################################################*/

import { throttle } from '../utilities/_throttleDebounce'
import { formatCurrency } from '../utilities/_commerce'
import { productEntries } from "../gql/_productQueries"

export function header() {
  return {
		accountOpen: false,
		basketOpen: false,
		searchOpen: false,
		isMobile: false,
		currentSubmenuOpen: null,
		hoveredSubmenuImage: null,
		searchValue: '',
		searchResults: [],
		items: [],

		config: {
			main: 'main',
			header: '.header',
			headerInner: '.header__inner',
			headerBackdrop: '.header__backdrop',
			headerNav: '.header__nav',
			headerMenuBtn: '.header__menu-btn',
			headerSubMenu: '.header__submenu',
			headerSubMenuSingle: '.header__submenu--single',
			headerSubMenuTrigger: '.header__nav__item--sub',
			headerSearchInput: '#headerSearchInput'
		},

		elements: {},

		init() {
			this.elements.header = document.querySelector(this.config.header)

			if (this.elements.header !== null) {
				this.elements.main = document.querySelector(this.config.main)
				this.elements.headerInner = document.querySelector(this.config.headerInner)
				this.elements.headerBackdrop = this.elements.header.querySelector(this.config.headerBackdrop)
				this.elements.headerNav = this.elements.header.querySelector(this.config.headerNav)
				this.elements.headerMenuBtn = this.elements.header.querySelector(this.config.headerMenuBtn)
				this.elements.headerSubMenus = this.elements.header.querySelectorAll(this.config.headerSubMenu)
				this.elements.headerSubMenuSingles = this.elements.header.querySelectorAll(this.config.headerSubMenuSingle)
				this.elements.headerSubMenuTriggers = this.elements.header.querySelectorAll(this.config.headerSubMenuTrigger)
				this.elements.headerSearchInput = this.elements.header.querySelector(this.config.headerSearchInput)

				// Handle scroll
				//
				this.handleScroll()

				// Handle backdrop
				//
				this.handleBackdropClick()

				// Handle menu btn
				//
				this.handleMenuBtn()

				// Handle menu items
				//
				this.handleMenuItems()

				setTimeout(() => {
					// Handle sub menu singles
					//
					this.handleSubMenuSingles()
				}, 500)

				// Set nav height
				//
				if (window.innerWidth < 1024) {
					this.setNavHeight()

					this.isMobile = true
				} else {
					this.isMobile = false
				}

				window.addEventListener('resize', throttle(() => {
					if (window.innerWidth < 1024) {
						this.setNavHeight()

						this.isMobile = true
					} else {
						this.unsetNavHeight()

						if (this.isMobile === true) {
							this.resetMenuState()
						}

						this.isMobile = false
					}

					this.handleSubMenuSingles()
				}, 250))

				// If local storage has accountOpenOnSubmit, open account and set to false.
				// This is used to reopen the account menu after a user submits the login form.
				//
				if (localStorage.getItem('accountOpenOnSubmit') === 'true') {
					this.accountOpen = true
					localStorage.removeItem('accountOpenOnSubmit')
				}

				this.$watch('basketOpen', (state) => {
					if (state === true) {
						this.accountOpen = false
						this.searchOpen = false
						this.currentSubmenuOpen = null
					}
				})

				this.$watch('accountOpen', (state) => {
					if (state === true) {
						this.currentSubmenuOpen = null
						this.basketOpen = false
						this.searchOpen = false
					}
				})

				this.$watch('searchOpen', (state) => {
					if (state === true) {
						this.currentSubmenuOpen = null
						this.accountOpen = false
						this.basketOpen = false
						this.elements.headerSearchInput.focus()
					}
				})

				// Initial submenu tabindexes
				//
				for (let i = 0; i < this.elements.headerSubMenus.length; i++) {
					this.setSubMenuTabIndexes(this.elements.headerSubMenus[i], false)
				}

				this.$watch('currentSubmenuOpen', (state) => {
					if (state !== null) {
						this.accountOpen = false
						this.basketOpen = false
						this.searchOpen = false

						for (let i = 0; i < this.elements.headerSubMenus.length; i++) {
							this.setSubMenuTabIndexes(this.elements.headerSubMenus[i], false)
						}

						const activeSubMenu = this.elements.header.querySelector(`#nav-submenu-${state}`)

						if (activeSubMenu) {
							this.setSubMenuTabIndexes(activeSubMenu, true)
						}
					} else {
						for (let i = 0; i < this.elements.headerSubMenus.length; i++) {
							this.setSubMenuTabIndexes(this.elements.headerSubMenus[i], false)
						}
					}
				})
			}
		},

		handleScroll() {
			let scrollPosition = window.pageYOffset || document.documentElement.scrollTop

			// Initial check
			//
			if (scrollPosition > 20) {
				this.elements.main.classList.add('header--scrolled')
				this.elements.header.classList.add('header--scrolled')
			} else {
				this.elements.main.classList.remove('header--scrolled')
				this.elements.header.classList.remove('header--scrolled')
			}

			setTimeout(() => {
				// Set nav height
				//
				if (window.innerWidth < 1024) {
					this.setNavHeight()
				}
			}, 1000)

			let lastScrollTop = 0

			window.addEventListener('scroll', throttle(() => {
				scrollPosition = window.scrollY || document.documentElement.scrollTop

				if (scrollPosition > 5) {
					this.elements.main.classList.add('header--scrolled')
					this.elements.header.classList.add('header--scrolled')
				} else {
					this.elements.main.classList.remove('header--scrolled')
					this.elements.header.classList.remove('header--scrolled')
				}

				if (scrollPosition > 20 && window.innerWidth >= 1024) {
					if (lastScrollTop > scrollPosition) {
						this.elements.header.classList.add('header--scrolling-up')
					} else {
						this.elements.header.classList.remove('header--scrolling-up')
					}
				} else {
					this.elements.header.classList.remove('header--scrolling-up')
				}
				lastScrollTop = scrollPosition <= 0 ? 0 : scrollPosition

				setTimeout(() => {
					// Set nav height
					//
					if (window.innerWidth < 1024) {
						this.setNavHeight()
					}
				}, 500)
			}, 250))
		},

		setNavHeight() {
			this.elements.headerNav.style.height = (window.innerHeight) + "px"
		},

		unsetNavHeight() {
			this.elements.headerNav.style.height = ""
		},

		handleMenuBtn() {
			this.elements.headerMenuBtn.addEventListener('click', (e) => {
				e.preventDefault()

				if (this.elements.header.classList.contains('header--open')) {
					this.elements.header.classList.remove('header--open')
					window.app.enableScroll()

					// Reset sub menus
					//
					setTimeout(() => {
						// Remove potential classes
						//
						this.elements.header.classList.remove('header--sub-open')
						this.elements.headerNav.classList.remove('overflow-hidden')
						this.currentSubmenuOpen = null

						// Reset nav scroll
						//
						this.elements.headerNav.scrollTop = 0

						// Reset nav overflow
						//
						this.elements.headerNav.style.overflowY = ''
					}, 500)
				} else {
					this.elements.header.classList.add('header--open')
					window.app.disableScroll()
					this.searchOpen = false
					this.basketOpen = false
					this.accountOpen = false
				}
			})
		},

		resetMenuState() {
			this.elements.header.classList.remove('header--open')
			window.app.enableScroll()

			// Reset sub menus
			//
			setTimeout(() => {
				// Reset nav scroll
				//
				this.elements.headerNav.scrollTop = 0

				// Reset nav overflow
				this.elements.headerNav.style.overflowY = ''
			}, 500)
		},

		handleMenuItems() {
			for (let k = 0; k < this.elements.headerSubMenuTriggers.length; k++) {
				const headerSubMenuTrigger = this.elements.headerSubMenuTriggers[k]

				if (headerSubMenuTrigger.nextElementSibling !== null) {
					headerSubMenuTrigger.addEventListener('keyup', (e) => {
						if (e.key === 'Enter' || e.keyCode === 13) {
							headerSubMenuTrigger.click()
						}
					})
				}
			}
		},

		handleSubMenuSingles() {
			if (this.elements.headerSubMenuSingles !== null && window.innerWidth >= 1024) {
				for (let i = 0; i < this.elements.headerSubMenuSingles.length; i++) {
					const headerSubMenuSingle = this.elements.headerSubMenuSingles[i]
					const parentNavItem = headerSubMenuSingle.previousElementSibling
					const navRect = this.elements.headerInner.getBoundingClientRect()
					const parentRect = parentNavItem.getBoundingClientRect()
					const firstColWidth = headerSubMenuSingle.querySelector('.col-span-full').offsetWidth
					const leftPosition = (parentRect.left - navRect.left) + (parentRect.width / 2) - (firstColWidth / 2 + 16)

					headerSubMenuSingle.style.left = leftPosition + 'px'
				}
			} else {
				for (let i = 0; i < this.elements.headerSubMenuSingles.length; i++) {
					const headerSubMenuSingle = this.elements.headerSubMenuSingles[i]
					headerSubMenuSingle.style.left = ''
				}
			}
		},

		setSubMenuTabIndexes(headerSubMenu, isFocusable) {
			const focusableElements = headerSubMenu.querySelectorAll('a, button')

			for (let i = 0; i < focusableElements.length; i++) {
				const focusableElement = focusableElements[i]

				if (isFocusable === true) {
					focusableElement.tabIndex = '0'
				} else {
					focusableElement.tabIndex = '-1'
				}
			}
		},

		handleBackdropClick() {
			this.elements.headerBackdrop.addEventListener('click', () => {
				window.app.enableScroll()
				this.currentSubmenuOpen = null
				this.searchOpen = false
				this.basketOpen = false
				this.accountOpen = false

				setTimeout(() => {
					this.searchValue = ''
				}, 500)
			})
		},

		backdropActive() {
			return this.searchOpen || this.basketOpen || this.accountOpen || this.currentSubmenuOpen;
		},

		handleEscape() {
			if (this.backdropActive()) {
				window.app.enableScroll()
				this.currentSubmenuOpen = null
				this.searchOpen = false
				this.basketOpen = false
				this.accountOpen = false

				setTimeout(() => {
					this.searchValue = ''
				}, 500)
			}
		},

		handleSearch() {
			if (this.searchValue.length < 2) {
				this.searchResults = []
				return
			} else {
				fetch("/api", {
					method: "POST",
					credentials: 'same-origin',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({
						query: productEntries,
						variables: {
							limit: 9,
							term: `${this.searchValue}*`
						},
					}),
				})
				.then((response) => response.json())
				.then(({ data }) => {
					this.searchResults = data?.products

					this.searchResults.forEach((product, index) => {
						const lowestPrice = Math.min(...product.variants.map(v => v.price))
						this.searchResults[index]['lowestPrice'] = formatCurrency(lowestPrice)
					});

					if (this.searchValue.length > 4) {
						fetch("/actions/search-module/search/log", {
							method: "POST",
							credentials: "same-origin",
							headers: {
								"Content-Type": "application/json",
								"X-CSRF-Token": window.csrfTokenValue,
							},
							body: JSON.stringify({
								keywords: this.searchValue,
								results: data?.products?.length || 0,
								pageUrl: window.location.pathname
							})
						})
						.then((response) => response.json())
						.then(({ data }) => {
							// console.log(data);
						})
					}
				})
				.finally(() => {
					this.loading = false;
				});
			}
		},

		getLineItemPrice(price, salePrice, qty) {
			if (salePrice) {
				return formatCurrency(salePrice * qty)
			} else {
				return formatCurrency(price * qty)
			}
		},

		getTotal(price) {
			return formatCurrency(this.$store.cart.totalPrice)
		}
	}
}
